export const homeFeatureKey = 'home';
